import { Configs } from 'utils/constants';

function ExtLink({ to, text }: { to: string; text: string }) {
  return (
    <a
      data-durable-id="extLinkId"
      data-intercom-target="extLinkId"
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      className="hover:opacity-70 underline"
    >
      {text}
    </a>
  );
}

function TosPrivacyLinks({ type }: { type: 'creating' | 'signin' }) {
  return (
    <>
      {type === 'creating'
        ? 'By creating an account, you agree to the platform '
        : 'By signing in, you agree to the platform '}
      <ExtLink to={Configs.Help.TermsOfService} text="Terms of Service" />
      {' and acknowledge that you have read our '}
      <ExtLink to={Configs.Help.PrivacyPolicy} text="Privacy Statement" />
    </>
  );
}

export default TosPrivacyLinks;
